import { deleteRole } from '@infuse/api/iam/role';
import { useGenericDeleteRole } from './generic/useGenericDeleteRole';
import { useCurrentUserStore } from '@infuse/iam/user/store';
import { UserLevel } from '@infuse/iam/user/type';
import { deleteOrganisationRole } from '@infuse/api/iam/organisation';
import { deleteTenantRole } from '@infuse/api/iam/tenant';

export const useDeleteRole = () => {
  const { level, user } = useCurrentUserStore();

  if (level === UserLevel.TENANT) {
    return useGenericDeleteRole({
      apiFn: deleteTenantRole,
      forcedParentId: user?.tenantId
    });
  } else if (level === UserLevel.ORGANISATION) {
    return useGenericDeleteRole({
      apiFn: deleteOrganisationRole,
      forcedParentId: user?.organisationId
    });
  }

  return useGenericDeleteRole({
    apiFn: deleteRole
  });
};
